import React, { useState, useEffect } from 'react';
import './LoginPromptModal.css';
import Modal from './Modal';

function LoginPromptModal({ isOpen, onClose, onFacebookLogin, onLogin, onShowSignUp, message, saving }) {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [isMessenger, setIsMessenger] = useState(false);

  useEffect(() => {
    const ua = navigator.userAgent || '';
    if (ua.includes('FBAN') || ua.includes('FBAV')) {
      setIsMessenger(true);
    }
  }, [])

  const handleEmailLogin = async (e) => {
    e.preventDefault();
    try {
      const response = await onLogin(email, password);
      if (!response.userExists) {
        setError('Invalid email or password');
      }
      if (response.userExists) {
        setEmail('')
        setPassword('')
      }
    } catch (err) {
      setError('Invalid email or password');
    }
  };

  const innerClose = () => {
    setEmail('')
    setPassword('')
    setError('')
    onClose()
  }

  return (
    <Modal
      isOpen={isOpen}
      title="Log In"
      onClose={innerClose}
    >
      {message && (
        <>
          <h2>Login Required</h2>
          <p>{message}</p>
        </>
      )}

      {isMessenger && (
        <div className="messenger-warning" style={{ background: '#fff4e5', border: '1px solid #ffa726', padding: '1em', borderRadius: '8px', marginBottom: '1em' }}>
          <strong>⚠ Facebook Login Disabled:</strong>
          <p style={{ margin: '0.5em 0 0 0' }}>
            It looks like you're using Facebook Messenger's built-in browser, which doesn't support Facebook login properly.
            To log in with Facebook, please tap the <strong>•••</strong> menu and choose <strong>"Open in external browser"</strong>, then try again.
          </p>
        </div>
      )}

      <div className="login-options">
        <div className="login-section">
          <button
            className="login-button facebook"
            onClick={onFacebookLogin}
            disabled={saving || isMessenger}
            title={isMessenger ? "Facebook login is disabled in this browser" : ""}
          >
            Login with Facebook
          </button>
        </div>

        {/* <div className="divider">
          <span>or</span>
        </div> */}

        {/* <div className="login-section">
          <form onSubmit={handleEmailLogin}>
            <div className="form-group gapped-form-group">
              <input
                type="email"
                placeholder="Email"
                value={email}
                onChange={(e) => {
                  setEmail(e.target.value);
                  setError('');
                }}
                required
                className={error ? 'error' : ''}
              />
            </div>
            <div className="form-group">
              <input
                type="password"
                placeholder="Password"
                value={password}
                onChange={(e) => {
                  setPassword(e.target.value);
                  setError('');
                }}
                required
                className={error ? 'error' : ''}
              />
              {error && <div className="error-message">{error}</div>}
            </div>
            <button
              type="submit"
              className="login-button email continue-button"
              disabled={!email || !password || saving}
            >
              Log in
            </button>
          </form>
        </div> */}
      </div>

      <div className="signup-prompt">
        New to Surgery Journey?{' '}
        <button
          className="signup-link"
          onClick={onShowSignUp}
          style={{ color: '#3498db' }}
        >
          Sign up
        </button>
      </div>
    </Modal>
  );
}

export default LoginPromptModal;
